<a [href]="fileAsset().url" target="_blank" class="guide-document-card">
  <div class="card">
    <img
      [src]="fileAsset().thumbnailUrl"
      [alt]="fileAsset().title + ' thumbnail'"
      class="img"
    />
    <div class="bottom">
      <gc-link
        class="title"
        [externalLinkUrl]="fileAsset().url"
        target="_blank"
        >{{ fileAsset().title }}</gc-link
      >
      <gc-icon
        [iconName]="'arrowUpRightFromSquare'"
        [color]="'invert'"
        [size]="'small'"
      />
    </div>
  </div>
</a>
